import React from "react";
import "./Importance.scss";
import importance from "../../../assets/importance.png";

const Importance = () => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className=" importance">
          <div className="container">
            <div className="importance_content">
              <div className="row">
                <div className="col-lg-5 left">
                  <h2>Why Is Insurance Important?</h2>
                  <p className="mb-4">
                    Buying insurance is important as it ensures that you are
                    financially secure to face any type of problem in life, and
                    this is why insurance is a very important part of financial
                    planning.
                  </p>
                  <p>
                    A general insurance company offers insurance policies to
                    secure health, travel, motor vehicle, and home. The
                    convenient part of it is that you can purchase all these
                    insurance policies online nowadays.
                  </p>
                </div>
                <div className="col-lg-7 right">
                  <img src={importance} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Importance;
